import Viewer from "viewerjs";
//图片预览
function previewImage(image) {
    if (
        Object.prototype.toString.call(image) !== "[object Array]" ||
        image.length < 1
    ) {
        return false;
    }
    let template = "";
    for (let i = 0; i < image.length; i++) {
        template += `<li><img data-original="${image[i]}" src="${image[i]}" alt="图片${i}"></li>`;
    }
    let $_mainId = "_img-30-view";
    let ele = document.getElementById($_mainId);
    if (ele === null) {
        let div = document.createElement("div");
        div.setAttribute("id", $_mainId);
        document.body.appendChild(div);
    }
    document.getElementById($_mainId).innerHTML = template;
    let viewer = new Viewer(document.getElementById($_mainId), {
        url: "data-original",
        hide() {
            this.viewer.destroy();
            let ele = document.getElementById($_mainId);
            if (ele !== null) {
                ele.remove();
            }
        }
    });
    viewer.view(0);
}
export { previewImage };



// WEBPACK FOOTER //
// ./src/tool/viewerImage.js